import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TouchableOpacity, Dimensions } from 'react-native';
import LottieView from "lottie-react-native";
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { BottomBarDLSType, ButtonSizeDLS, ButtonTypeDLS, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, KeyboardTypeToken, TextAlignTokens, TypographyTypeDLS } from '@voltmoney/schema';
import BottomBar from '../../bottomBarDLS/bottomBarDLS';
import Typography from '../../typography/Typography';
import BottomSheet from '../BottomSheet';
import Icon from '../../icon/Icon';
import Divider from '../../divider/Divider';
import { DropdownInput } from '../../dropDownInput/DropDownBaseInput';
import { PAN_TYPE } from './types';
import TextInput from '../../textInput/TextInput';
import { RegexConfig } from '../constants';
import ListItem from './ListItem';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import { ModalAlignmentEnum } from '@voltmoney/types';
import { isMobileView } from '../../stack/utils';
import DropDownComp from '../DropDownComp';
const panTypeData = [
    { label: 'Resident Individual (Self)', value: PAN_TYPE.RESIDENT_INDIVIDUAL_SELF },
    { label: 'Resident Individual (Other)', value: PAN_TYPE.RESIDENT_INDIVIDUAL_OTHER },
    { label: 'Private Limited Company', value: PAN_TYPE.PRIVATE_LIMITED },
    { label: 'Limited Liability Partnership', value: PAN_TYPE.LLP },
    { label: 'Sole proprietor', value: PAN_TYPE.SOLE_PROPRIETOR },
    { label: 'Partnership', value: PAN_TYPE.PARTNERSHIP },
    { label: 'HUF', value: PAN_TYPE.HUF },
    { label: 'OPC (One-Person Company)', value: PAN_TYPE.OPC },
    { label: 'Other', value: PAN_TYPE.OTHER },
];
const PayoutDetailPage = ({ height, validatebank, panState, gstState, ifscState, bankDetail, showPennyModal, showErrorModal, showSuccessModal, modalHeight, closeAction, panValidateAction, gstValidateAction, ifscValidateAction, ifscAction, bankData, selectedPanType = '', selectedPanNumber = '', selectedGstNumber = '', selectedBankAccountNumber = '', selectedIfscCode = '', closeModalAction, errorHeading, message, triggerAction }) => {
    const [panType, setPanType] = useState(selectedPanType);
    const [otherPanType, setOtherPanType] = useState('');
    const [panNumber, setPanNumber] = useState(selectedPanNumber);
    const [showbankDetails, setShowBankDetails] = useState(false);
    const [showIfscDetails, setShowIfscDetails] = useState(false);
    const [showPanDetails, setShowPanDetails] = useState(true);
    const [bankName, setBankName] = useState();
    const [bankLabel, setBankLabel] = useState();
    const [bankAccountNumber, setBankAccountNumber] = useState(selectedBankAccountNumber);
    const [reBankAccountNumber, setReBankAccountNumber] = useState(selectedBankAccountNumber);
    const [ifscNumber, setIfscNumber] = useState(selectedIfscCode);
    const [gstNumber, setGstNumber] = useState(selectedGstNumber);
    const [arnNumber, setArnNumber] = useState('');
    const [bankAccountState, setBankAccountState] = useState(InputStateToken.DEFAULT);
    const [branchName, setBranchName] = useState('');
    const [rupeeLottie, setRupeeLottie] = useState("");
    const [ifscDescription, setIfscDescription] = useState('');
    useEffect(() => {
        fetch("https://lottie.host/78420adf-df0a-4fa2-a500-36bbf2ac0762/YkUlAx1j0n.json", {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setRupeeLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
    }, []);
    const checkButtonState = () => {
        let isButtonDisabled = true;
        if (showbankDetails) {
            if (bankAccountState === InputStateToken.DEFAULT && ifscState === InputStateToken.SUCCESS)
                isButtonDisabled = false;
            else
                isButtonDisabled = true;
        }
        else {
            if (panType !== '' && gstState === InputStateToken.DEFAULT && panState === InputStateToken.SUCCESS) {
                isButtonDisabled = false;
            }
            else
                isButtonDisabled = true;
        }
        return isButtonDisabled;
    };
    const footerChild = () => {
        return (React.createElement(View, { style: {} },
            React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_A, btnLabel: showbankDetails ? 'Verify bank account' : 'Continue to add bank details', btnTypeDLS: ButtonTypeDLS.PRIMARY, btnSizeDLS: ButtonSizeDLS.MEDIUM, onPress: async () => {
                    if (!showbankDetails) {
                        setShowBankDetails(true);
                        setShowPanDetails(false);
                        setShowIfscDetails(false);
                    }
                    else {
                        if (validatebank)
                            await triggerAction({
                                ...validatebank,
                                payload: {
                                    panType,
                                    panNumber,
                                    gstNumber,
                                    ifscNumber,
                                    bankAccountNumber,
                                    otherPanTypeDetail: '',
                                }
                            });
                    }
                }, isDisabled: checkButtonState(), children: showbankDetails ?
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'We\u2019ll deposit \u20B91 to verify your bank account', typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })) : React.createElement(React.Fragment, null) })));
    };
    const handleCrossAction = async () => {
        if (closeAction)
            await triggerAction(closeAction);
    };
    const handleBackAction = () => {
        if (showbankDetails) {
            setShowBankDetails(false);
            setShowPanDetails(true);
        }
        else {
            setShowBankDetails(true);
            setShowIfscDetails(false);
        }
    };
    const renderBankDetailsContent = () => {
        return (React.createElement(View, null,
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: 16 } },
                React.createElement(View, { style: { flexDirection: 'row' } },
                    showbankDetails && React.createElement(TouchableOpacity, { style: { paddingRight: 4 }, hitSlop: { top: 16, left: 16, right: 16, bottom: 16 }, onPress: handleBackAction },
                        React.createElement(Icon, { name: IconTokens.BackArrowIcon, size: IconSizeTokens.XL, color: ColorTokens.Grey_Night })),
                    React.createElement(Typography, { label: 'Enter payout details', typeDLS: TypographyTypeDLS.H4B, color: ColorTokens.Grey_Night })),
                React.createElement(TouchableOpacity, { hitSlop: { top: 16, left: 16, right: 16, bottom: 16 }, onPress: handleCrossAction },
                    React.createElement(Icon, { name: IconTokens.Cross, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Night }))),
            React.createElement(View, { style: { marginBottom: 4 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', padding: 16 } },
                React.createElement(View, { style: { justifyContent: 'center', alignItems: 'center' } },
                    React.createElement(Icon, { name: showbankDetails ? IconTokens.CheckCircle : IconTokens.RadioCircleFilled, color: ColorTokens.Primary_100, size: IconSizeTokens.XL }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3M, color: ColorTokens.Primary_100, label: 'Invoice details' })),
                React.createElement(View, { style: {
                        height: 1,
                        backgroundColor: '#E4E7EC',
                        flexGrow: 1,
                        marginTop: 8,
                    } }),
                React.createElement(View, { style: { justifyContent: 'center', alignItems: 'center' } },
                    React.createElement(Icon, { name: showbankDetails ? IconTokens.RadioCircleFilled : IconTokens.RadioCircleNotFilled, color: ColorTokens.Primary_100, size: IconSizeTokens.XL }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3M, color: showbankDetails ? ColorTokens.Primary_100 : ColorTokens.Grey_Smoke, label: 'Bank details' }))),
            showPanDetails && (React.createElement(View, null,
                React.createElement(View, { style: { marginTop: 16, paddingHorizontal: 16 } },
                    React.createElement(DropdownInput, { label: 'Select PAN type*', data: panTypeData, height: 180, value: panType, onValueSelect: (value) => {
                            if (value !== "")
                                setPanType(value);
                        } })),
                panType === 'OTHER' && React.createElement(View, { style: { marginTop: 24, paddingHorizontal: 16 } },
                    React.createElement(TextInput, { state: InputStateToken.DEFAULT, isFocus: false, value: otherPanType, keyboardType: KeyboardTypeToken.default, showErrorOnFocus: false, title: 'Enter PAN Type', placeholder: 'PAN Type', onChangeText: (text) => {
                            setOtherPanType(text);
                        }, caption: {
                            error: ``
                        } })),
                React.createElement(View, { style: { marginTop: 24, paddingHorizontal: 16 } },
                    React.createElement(TextInput, { state: panState, regex: RegexConfig.PAN, charLimit: 10, isUpperCase: true, isFocus: false, value: panNumber, keyboardType: KeyboardTypeToken.default, showErrorOnFocus: false, title: 'PAN number*', onChangeText: async (text) => {
                            setPanNumber(text);
                            if (panValidateAction)
                                await triggerAction({
                                    ...panValidateAction,
                                    payload: {
                                        panNumber: text
                                    }
                                });
                        }, caption: {
                            error: `${panState === InputStateToken.ERROR ? 'Enter a valid PAN' : ''}`
                        } })),
                React.createElement(View, { style: { marginTop: 24, paddingHorizontal: 16 } },
                    React.createElement(TextInput, { state: gstState, isFocus: false, value: gstNumber, keyboardType: KeyboardTypeToken.default, showErrorOnFocus: false, title: 'GST number', placeholder: 'GST number (Optional)', onChangeText: async (text) => {
                            setGstNumber(text);
                            if (gstValidateAction)
                                await triggerAction({
                                    ...gstValidateAction,
                                    payload: {
                                        panNumber,
                                        gstNumber: text,
                                    }
                                });
                        }, caption: {
                            error: `${gstState === InputStateToken.ERROR ? 'Please enter a valid GST number' : ''}`
                        } })))),
            showbankDetails && (React.createElement(View, { style: { paddingHorizontal: 16 } },
                React.createElement(View, { style: { backgroundColor: '#F1F3F5', padding: 12, flexDirection: 'row', borderRadius: 8, flexShrink: 1 } },
                    React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, color: ColorTokens.Grey_Charcoal, size: IconSizeTokens.XL }),
                    React.createElement(View, { style: { marginLeft: 8 } },
                        React.createElement(Typography, { label: 'Enter bank account linked with PAN ', color: ColorTokens.Grey_Charcoal, typeDLS: TypographyTypeDLS.B2R })),
                    React.createElement(Typography, { label: panNumber, color: ColorTokens.Grey_Night, typeDLS: TypographyTypeDLS.B2B })),
                React.createElement(View, { style: { marginTop: 16 } },
                    React.createElement(TextInput, { state: InputStateToken.DEFAULT, isFocus: false, value: bankAccountNumber, secureTextEntry: true, keyboardType: KeyboardTypeToken.default, title: 'Bank account number*', onChangeText: (text) => {
                            setBankAccountNumber(text);
                            if (reBankAccountNumber !== '' && text !== reBankAccountNumber)
                                setBankAccountState(InputStateToken.ERROR);
                            else
                                setBankAccountState(InputStateToken.DEFAULT);
                        } })),
                React.createElement(View, { style: { marginTop: 16 } },
                    React.createElement(TextInput, { state: bankAccountState, isFocus: false, value: reBankAccountNumber, keyboardType: KeyboardTypeToken.default, showErrorOnFocus: false, title: 'Re-enter bank account number*', onChangeText: (text) => {
                            setReBankAccountNumber(text);
                            if (text === bankAccountNumber)
                                setBankAccountState(InputStateToken.DEFAULT);
                            else
                                setBankAccountState(InputStateToken.ERROR);
                        }, caption: {
                            error: `${bankAccountState === InputStateToken.ERROR ? 'Please enter same bank account number' : ''}`
                        } })),
                React.createElement(View, { style: { marginTop: 16 } },
                    React.createElement(TextInput, { state: ifscState, isFocus: false, value: ifscNumber, isUpperCase: true, keyboardType: KeyboardTypeToken.default, showErrorOnFocus: false, title: 'IFSC*', onChangeText: async (text) => {
                            setIfscNumber(text);
                            if (ifscValidateAction)
                                await triggerAction({
                                    ...ifscValidateAction,
                                    payload: {
                                        ifscNumber: text
                                    }
                                });
                        }, caption: {
                            error: `${ifscState === InputStateToken.ERROR ? 'Please enter a valid IFSC number' : ''}`
                        } })),
                React.createElement(TouchableOpacity, { style: { marginTop: 8 }, activeOpacity: ifscDescription === '' ? 0 : 1, onPress: () => {
                        if ((ifscDescription === '' || ifscNumber === '')) {
                            setShowIfscDetails(true);
                            setShowBankDetails(false);
                            setShowPanDetails(false);
                        }
                    } },
                    React.createElement(Typography, { label: (ifscDescription && ifscNumber) ? ifscDescription : 'Click here to know your IFSC', color: (ifscDescription && ifscNumber) ? ColorTokens.Grey_Night : ColorTokens.Primary_100, typeDLS: TypographyTypeDLS.B2R }))))));
    };
    const renderIfscContent = () => {
        return (React.createElement(View, { style: {} },
            React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', padding: 16 } },
                React.createElement(TouchableOpacity, { hitSlop: { top: 16, left: 16, right: 16, bottom: 16 }, style: { paddingRight: 4 }, onPress: handleBackAction },
                    React.createElement(Icon, { name: IconTokens.BackArrowIcon, size: IconSizeTokens.XL, color: ColorTokens.Grey_Night })),
                React.createElement(Typography, { label: 'Search IFSC', typeDLS: TypographyTypeDLS.H4B, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginBottom: 4 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(View, { style: { marginTop: 28, paddingHorizontal: 16, zIndex: 1000 } },
                React.createElement(DropDownComp, { label: bankLabel ? bankLabel : 'Bank name*', Data: bankDetail, value: bankName, onValueSelect: (bank) => {
                        if (bank !== "") {
                            setBankName(bank.value);
                            setBankLabel(bank.label);
                        }
                    } })),
            React.createElement(View, { style: { marginTop: 16, paddingHorizontal: 16 } },
                React.createElement(TextInput, { state: InputStateToken.DEFAULT, charLimit: 10, isUpperCase: true, isFocus: false, value: branchName, keyboardType: KeyboardTypeToken.default, title: 'Enter branch name*', onChangeText: async (text) => {
                        setBranchName(text);
                        await triggerAction({
                            ...ifscAction,
                            payload: {
                                value: text,
                                bankName,
                                ...ifscAction.payload,
                            }
                        });
                    } })),
            React.createElement(View, { style: { marginTop: 20 } },
                React.createElement(ListItem, { bankData: bankData, triggerAction: triggerAction, setIfscNumber: setIfscNumber, setShowBankDetails: setShowBankDetails, setShowIfscDetails: setShowIfscDetails, setIfscDescription: setIfscDescription }))));
    };
    const ErrorModal = () => {
        return (React.createElement(View, { style: { padding: 16 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.Size36 })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night, label: errorHeading, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginTop: 16, borderRadius: 8, backgroundColor: '#FEF4E6', padding: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, color: ColorTokens.Grey_Night, label: message, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Edit bank details', onPress: handleCloseBaseModal, isDisabled: false }))));
    };
    const SuccessModal = () => {
        return (React.createElement(View, { style: { padding: 16 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.Success, size: IconSizeTokens.Size36 })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night, label: "Account verified successfully!", textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginTop: 16, borderRadius: 8, backgroundColor: '#FEF4E6', padding: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, color: ColorTokens.Grey_Night, label: "Unlock your earnings now by completing the client's loan application", textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Done', onPress: handleCloseBaseModal, isDisabled: false }))));
    };
    const PennyDrop = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1, alignItems: 'center' }, onPress: () => { } },
            React.createElement(LottieView, { source: rupeeLottie, style: { width: 99, height: 'auto' }, autoPlay: true, loop: true }),
            React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, label: "Depositing ₹1", fontWeight: 'bold', fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, paddingTop: 16 }),
            React.createElement(View, { style: { position: 'absolute', bottom: 0, marginBottom: 14 } },
                React.createElement(Typography, { label: "It may take up to 30 seconds..." }))));
    };
    const modalContentPresenter = () => {
        if (showPennyModal)
            return PennyDrop();
        else if (showErrorModal)
            return ErrorModal();
        else
            return SuccessModal();
    };
    const handleCloseBaseModal = async () => {
        if (closeModalAction)
            await triggerAction({
                ...closeModalAction,
                payload: {
                    showErrorModal,
                }
            });
    };
    const modalScreen = () => {
        return (showPennyModal || showErrorModal || showSuccessModal) ? (React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                zIndex: 99,
            } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: handleCloseBaseModal, alignment: ModalAlignmentEnum.BOTTOM, backgroundColorPartner: '#1D293999', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: Dimensions.get('window').height, screenWidth: isMobileView() ? Dimensions.get('window').width : 360, routeId: 'routeId', handleKeyboard: true }, modalContentPresenter()))) : React.createElement(React.Fragment, null);
    };
    const renderContent = () => {
        return showIfscDetails ? renderIfscContent() : renderBankDetailsContent();
    };
    return (React.createElement(BoilerPlate, { height: height, backgroundColor: ColorTokens.White, bottomChildren: showIfscDetails ? React.createElement(React.Fragment, null) :
            React.createElement(React.Fragment, null,
                footerChild(),
                modalScreen()) },
        React.createElement(React.Fragment, null, renderContent())));
};
const styles = StyleSheet.create({});
export default PayoutDetailPage;
